import type { ReactElement, ReactNode } from 'react';
import styles from './PageHeader.module.scss';

export interface PageHeaderProps {
  title: ReactNode;
  subtitle?: ReactNode;
  actions?: ReactNode;
}

/** Заголовок страницы (h1) с подзаголовком и действиями. */
export function PageHeader({ title, subtitle, actions }: PageHeaderProps): ReactElement {
  return (
    <header className={styles.header}>
      <div className="u-grow">
        <h1 className={styles.title}>{title}</h1>
        {subtitle ? <p className={styles.subtitle}>{subtitle}</p> : null}
      </div>
      {actions ? <div className="u-row">{actions}</div> : null}
    </header>
  );
}
